/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoFusionModelsUserBlank,
    SharedserviceMelcoFusionModelsUserBlankFromJSON,
    SharedserviceMelcoFusionModelsUserBlankToJSON,
    SharedserviceMelcoModelsAlphabetReferences,
    SharedserviceMelcoModelsAlphabetReferencesFromJSON,
    SharedserviceMelcoModelsAlphabetReferencesToJSON,
    SharedserviceMelcoModelsBoolResponse,
    SharedserviceMelcoModelsBoolResponseFromJSON,
    SharedserviceMelcoModelsBoolResponseToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet,
    SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabetToJSON,
    SharedserviceMelcoModelsUserAlphabet,
    SharedserviceMelcoModelsUserAlphabetFromJSON,
    SharedserviceMelcoModelsUserAlphabetToJSON,
} from '../models';

export interface AlphabetsDraftApiUserAlphabetDeleteRequest {
    id: string;
    force?: boolean;
}

export interface AlphabetsDraftApiUserAlphabetDownloadRequest {
    id: string;
    publishState?: string;
}

export interface AlphabetsDraftApiUserAlphabetDuplicateDraftRequest {
    id: string;
}

export interface AlphabetsDraftApiUserAlphabetGetRequest {
    id: string;
    publishState?: string;
}

export interface AlphabetsDraftApiUserAlphabetPreviewRequest {
    id: string;
    width?: number;
    publishState?: string;
}

export interface AlphabetsDraftApiUserAlphabetPublishRequest {
    id: string;
}

export interface AlphabetsDraftApiUserAlphabetReferencesRequest {
    id: string;
}

export interface AlphabetsDraftApiUserAlphabetRevertRequest {
    id: string;
}

export interface AlphabetsDraftApiUserAlphabetSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    service?: string;
    publishState?: string;
}

export interface AlphabetsDraftApiUserAlphabetUpdateDraftRequest {
    id: string;
    name?: string;
    recommendedText?: string;
    file?: Blob;
    binaryFileName?: string;
    binaryFileFileData?: string;
    binaryFileSignature?: string;
}

export interface AlphabetsDraftApiUserAlphabetsUploadDraftRequest {
    service?: string;
    file?: Blob;
}

/**
 * 
 */
export class AlphabetsDraftApi extends runtime.BaseAPI {

    /**
     */
    async userAlphabetDeleteRaw(requestParameters: AlphabetsDraftApiUserAlphabetDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userAlphabetDelete(requestParameters: AlphabetsDraftApiUserAlphabetDeleteRequest): Promise<void> {
        await this.userAlphabetDeleteRaw(requestParameters);
    }

    /**
     */
    async userAlphabetDownloadRaw(requestParameters: AlphabetsDraftApiUserAlphabetDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetDownload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/{Id}/download`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userAlphabetDownload(requestParameters: AlphabetsDraftApiUserAlphabetDownloadRequest): Promise<Blob> {
        const response = await this.userAlphabetDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetDuplicateDraftRaw(requestParameters: AlphabetsDraftApiUserAlphabetDuplicateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetDuplicateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/{Id}/duplicate/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetDuplicateDraft(requestParameters: AlphabetsDraftApiUserAlphabetDuplicateDraftRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userAlphabetDuplicateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetGetRaw(requestParameters: AlphabetsDraftApiUserAlphabetGetRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsUserAlphabet>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsUserAlphabetFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetGet(requestParameters: AlphabetsDraftApiUserAlphabetGetRequest): Promise<SharedserviceMelcoModelsUserAlphabet> {
        const response = await this.userAlphabetGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetPreviewRaw(requestParameters: AlphabetsDraftApiUserAlphabetPreviewRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetPreview.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.width !== undefined) {
            queryParameters['width'] = requestParameters.width;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/{Id}/preview`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userAlphabetPreview(requestParameters: AlphabetsDraftApiUserAlphabetPreviewRequest): Promise<void> {
        await this.userAlphabetPreviewRaw(requestParameters);
    }

    /**
     */
    async userAlphabetPublishRaw(requestParameters: AlphabetsDraftApiUserAlphabetPublishRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsBoolResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetPublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/{Id}/publish`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetPublish(requestParameters: AlphabetsDraftApiUserAlphabetPublishRequest): Promise<SharedserviceMelcoModelsBoolResponse> {
        const response = await this.userAlphabetPublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetReferencesRaw(requestParameters: AlphabetsDraftApiUserAlphabetReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetReferencesFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetReferences(requestParameters: AlphabetsDraftApiUserAlphabetReferencesRequest): Promise<SharedserviceMelcoModelsAlphabetReferences> {
        const response = await this.userAlphabetReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetRevertRaw(requestParameters: AlphabetsDraftApiUserAlphabetRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/{Id}/revert`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userAlphabetRevert(requestParameters: AlphabetsDraftApiUserAlphabetRevertRequest): Promise<void> {
        await this.userAlphabetRevertRaw(requestParameters);
    }

    /**
     */
    async userAlphabetSearchRaw(requestParameters: AlphabetsDraftApiUserAlphabetSearchRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.service !== undefined) {
            queryParameters['service'] = requestParameters.service;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetSearch(requestParameters: AlphabetsDraftApiUserAlphabetSearchRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet> {
        const response = await this.userAlphabetSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetUpdateDraftRaw(requestParameters: AlphabetsDraftApiUserAlphabetUpdateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsUserAlphabet>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetUpdateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.name !== undefined) {
            formParams.append('Name', requestParameters.name as any);
        }

        if (requestParameters.recommendedText !== undefined) {
            formParams.append('RecommendedText', requestParameters.recommendedText as any);
        }

        if (requestParameters.file !== undefined) {
            formParams.append('File', requestParameters.file as any);
        }

        if (requestParameters.binaryFileName !== undefined) {
            formParams.append('BinaryFile.Name', requestParameters.binaryFileName as any);
        }

        if (requestParameters.binaryFileFileData !== undefined) {
            formParams.append('BinaryFile.FileData', requestParameters.binaryFileFileData as any);
        }

        if (requestParameters.binaryFileSignature !== undefined) {
            formParams.append('BinaryFile.Signature', requestParameters.binaryFileSignature as any);
        }

        const response = await this.request({
            path: `/alphabets/{Id}/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsUserAlphabetFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetUpdateDraft(requestParameters: AlphabetsDraftApiUserAlphabetUpdateDraftRequest): Promise<SharedserviceMelcoModelsUserAlphabet> {
        const response = await this.userAlphabetUpdateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetsUploadDraftRaw(requestParameters: AlphabetsDraftApiUserAlphabetsUploadDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.service !== undefined) {
            queryParameters['service'] = requestParameters.service;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/alphabets/upload/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetsUploadDraft(requestParameters: AlphabetsDraftApiUserAlphabetsUploadDraftRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet> {
        const response = await this.userAlphabetsUploadDraftRaw(requestParameters);
        return await response.value();
    }

}
